import { render, staticRenderFns } from "./Subassembly.vue?vue&type=template&id=22d0ff05&scoped=true&"
import script from "./Subassembly.vue?vue&type=script&lang=ts&"
export * from "./Subassembly.vue?vue&type=script&lang=ts&"
import style0 from "./Subassembly.vue?vue&type=style&index=0&id=22d0ff05&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d0ff05",
  null
  
)

export default component.exports